import type { MetaFunctionEntry } from "./types";

/** Diagnostico descreve o tipo declarado; modo/unidade/nome nao o substituem. */
export function diagnosticValueKindLabel(kind: unknown): string {
  switch (kind) {
    case "instantaneous": return "Leitura instantânea";
    case "rate": return "Taxa";
    case "cumulative": return "Acumulado";
    case "state": return "Estado";
    default: return "Leitura";
  }
}

export function diagnosticFunctionKindLabel(fn: MetaFunctionEntry): string {
  const values = fn.values;
  if (!values || Array.isArray(values)) return "—";
  const parts: string[] = [];
  // s/acc sao slots de contrato; o valor v tem semantica variavel.
  if (values.s) parts.push("Estado");
  if (values.acc) parts.push("Acumulado");
  if (values.v) parts.push(diagnosticValueKindLabel(values.v.kind));
  return parts.length ? parts.join(" + ") : "—";
}
